module.exports = __webpack_public_path__ + "assets/images/jr_character.bf7286d.svg";